import React from 'react';

const DigestEmail = function DigestEmail() {
  return (
    <svg width="71px" height="70px" viewBox="0 0 71 70" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="AssetType_digest-BIG" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M67.0555556,70 C69.2340121,70 71,68.2588851 71,66.1111111 L71,3.88888889 C71,1.74111486 69.2340121,0 67.0555556,0 L3.94444444,0 C1.76598793,0 0,1.74111486 0,3.88888889 L0,66.1111111 C0,68.2588851 1.76598793,70 3.94444444,70 L67.0555556,70 Z M63.8101266,62.8205128 L32.3544304,62.8205128 L32.3544304,28.2482906 C32.3628732,28.1058203 32.3628732,27.9629832 32.3544304,27.8205128 L63.8101266,27.8205128 L63.8101266,62.8205128 Z M7.12862441,8 L64.0157719,8 L64.0157719,20.6410256 L7.12862441,20.6410256 L7.12862441,8 Z M7.18987342,27.8205128 L23.3670886,27.8205128 C23.3584046,27.9629832 23.3584046,28.1058203 23.3670886,28.2482906 L23.3670886,62.8205128 L7.18987342,62.8205128 L7.18987342,27.8205128 Z" id="Shape-Copy-5" stroke="#FFFFFF" fill="#7E7E7E" fillRule="nonzero" />
      </g>
    </svg>
  );
};

export default DigestEmail;
